module.exports = __webpack_public_path__ + "static/media/lq-720x130.59444478.jpg";